import { styled } from '@mui/material/styles';
import { default as BaseDetailValue } from './DetailValue';

export const Content = styled('div')(() => ({
  overflowY: 'auto'
}));

export const Description = styled('div')(({ theme }) => ({
  fontWeight: theme.fontWeight.light,
  padding: theme.spacing(1, 3, 4)
}));

export const DetailLabel = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1),
  whiteSpace: 'initial'
}));

export const DetailValue = styled(BaseDetailValue)(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const Detail = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  fontSize: theme.fontSize.small,
  overflow: 'hidden',
  padding: theme.spacing(2, 3),
  [`& ${DetailValue}`]: {
    marginTop: theme.spacing(1)
  }
}));

export const Details = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  [`& ${Detail}`]: {
    backgroundColor: theme.color.grey[100],
    '@media (min-width: 851px)': {
      flex: '1 1 33%',
      '&:nth-of-type(6n), &:nth-of-type(6n-1), &:nth-of-type(6n-2)': {
        backgroundColor: theme.color.grey[300]
      }
    },
    '@media (max-width: 850px) and (min-width: 401px)': {
      flex: '1 1 50%',
      '&:nth-of-type(4n), &:nth-of-type(4n-1)': {
        backgroundColor: theme.color.grey[300]
      }
    },
    '@media (max-width: 400px)': {
      flex: '1 1 100%',
      '&:nth-of-type(even)': {
        backgroundColor: theme.color.grey[300]
      }
    }
  }
}));

export const Title = styled('h3')(({ theme }) => ({
  fontSize: theme.fontSize.xlarge,
  fontWeight: theme.fontWeight.light,
  margin: theme.spacing(3)
}));

export const SectionTitle = styled('h3')(({ theme }) => ({
  fontSize: theme.fontSize.large,
  fontWeight: theme.fontWeight.light,
  margin: theme.spacing(3, 0, 2),
  textTransform: 'uppercase'
}));
